import { TimerService } from '@/services/stopwatch/timer.service'

// "key" is the game plus its period, see stopwatchKey() in '@/lib/stopwatch'
export const StopwatchService = {
  getTime (client, key) {
    return TimerService.get(`api/stopwatch/get-time/${client}/${key}`)
  },
  setTime (client, key, data) {
    return TimerService.put(`api/stopwatch/set-time/${client}/${key}`, data)
  },
  clearTime (client, key) {
    return TimerService.delete(`api/stopwatch/clear-time/${client}/${key}`)
  }
}
